import { render, staticRenderFns } from "./ShuiBiaoSheBeiDetails.vue?vue&type=template&id=719102da&scoped=true&"
import script from "./ShuiBiaoSheBeiDetails.vue?vue&type=script&lang=js&"
export * from "./ShuiBiaoSheBeiDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShuiBiaoSheBeiDetails.vue?vue&type=style&index=0&id=719102da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719102da",
  null
  
)

export default component.exports